<template>
	<div id="top" style="background-color: #efefef;height: 100%;" class="clearfix">
		<!-- <input id="ex1" data-slider-id="ex1Slider" type="text" data-slider-min="0" data-slider-max="20" data-slider-step="0.1"
		 data-slider-value="15" v-model="slidevalue" /> -->
		<div style="display: flex;justify-content: space-around; flex-wrap:wrap; width: 100%;padding: 20px;height: 100%;background-color:#f7f7f7;" class="middle-column around bai">
			<div class="middle-row around" style="width:45%; height: 250px; margin-bottom:10px;background-color: white;box-shadow: 2px 4px 6px grey;"
			 v-for="(item,i) in selects" :key='i'>
				<div style="width: 40%;vertical-align:middle;font-weight: 700;">{{item.name}}</div>
				<div class="level2-2 middle-column around" style="width: 40%;padding: 10px 0px;">
					<div class="level3 middle-row around" v-for="(value,key,index) in item.obj" :key="index">
						<div class="input-group" style="margin: 5px;">
							<span class="input-group-addon">请输入{{item.files[index]}}阈值</span>
							<input type="text" class="form-control" v-model="item.obj[key]">
						</div>
					</div>
				</div>
				<div style="width: 20%;">
					<button class="btn btn-success" style="color: white;" @click="updateStandard(i)"><b>更新</b></button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				slidevalue: '',
				selects: [{
					name: '餐饮油烟排放',
					files: ['油烟浓度', '颗粒物浓度', '非甲烷总烃'],
					obj: {lc:10,pc:10,nmthc:20},
				}, {
					name: 'VOCS排放',
					files: ['VOCS排放'],
					obj: {vocs:20},
				}, {
					name: '工地扬尘',
					files: ['pm25', 'pm10', '噪声', '温度', '湿度'],
					obj: {pm25:200, pm10:200, noise:200, temp:200, humidity:200},
				}, {
					name: '工业企业废气',
					java: 'CarRepair',
					files: ['湿度', '苯系物', '非甲烷总烃', '温度', '颗粒物'],
					obj: {bz:100, bzs:100, nmthc:100, temp:100, pc:100},
				}],
			}
		},
		methods: {
			updateStandard: function(i) {
				var type = this.selects[i].java;
				if (i == 0) {
					var lampblack = this.selects[i].obj;
					this.$http.post(this.GLOBAL.base + 'saveLampblackStandard', lampblack, {
						emulateJSON: true
					}).then(function(msg) {
						this.selects[i].obj.lc = msg.body.lampblack.lc;
						this.selects[i].obj.pc = msg.body.lampblack.pc;
						this.selects[i].obj.nmthc = msg.body.lampblack.nmthc;
						alert(this.selects[i].name+'阈值更新成功！')
					});
				} else if (i == 1) {
					var outerDoor = this.selects[i].obj;
					this.$http.post(this.GLOBAL.base + 'saveOuterDoorStandard', outerDoor, {
						emulateJSON: true
					}).then(function(msg) {
						this.selects[i].obj.vocs = msg.body.outerDoor.vocs;
						alert(this.selects[i].name+'阈值更新成功！')
					});
				} else if (i == 2) {
					var dust = this.selects[i].obj;
					this.$http.post(this.GLOBAL.base + 'saveDustStandard', dust, {
						emulateJSON: true
					}).then(function(msg) {
						this.selects[i].obj.pm25 = msg.body.dust.pm25;
						this.selects[i].obj.pm10 = msg.body.dust.pm10;
						this.selects[i].obj.noise = msg.body.dust.noise;
						this.selects[i].obj.temp = msg.body.dust.temp;
						this.selects[i].obj.humidity = msg.body.dust.humidity;
						alert(this.selects[i].name+'阈值更新成功！')
					});
				} else if (i == 3) {
					var carRepair = this.selects[i].obj;
					this.$http.post(this.GLOBAL.base + 'saveCarRepairStandard', carRepair, {
						emulateJSON: true
					}).then(function(msg) {
						this.selects[i].obj.bz = msg.body.carRepair.bz;
						this.selects[i].obj.bzs = msg.body.carRepair.bzs;
						this.selects[i].obj.nmthc = msg.body.carRepair.nmthc;
						this.selects[i].obj.temp = msg.body.carRepair.temp;
						this.selects[i].obj.pc = msg.body.carRepair.pc;
						alert(this.selects[i].name+'阈值更新成功！')
					});
				}
			},
		},
		mounted() {
			this.$http.get(this.GLOBAL.base+'getStandard').then(function(msg) {
				this.selects[0].obj.lc = msg.body.lampblack.lc;
				this.selects[0].obj.pc = msg.body.lampblack.pc;
				this.selects[0].obj.nmthc = msg.body.lampblack.nmthc;
				this.selects[1].obj.vocs = msg.body.outerDoor.vocs;
				this.selects[2].obj.pm25 = msg.body.dust.pm25;
				this.selects[2].obj.pm10 = msg.body.dust.pm10;
				this.selects[2].obj.noise = msg.body.dust.noise;
				this.selects[2].obj.temp = msg.body.dust.temp;
				this.selects[2].obj.humidity = msg.body.dust.humidity;
				this.selects[3].obj.bz = msg.body.carRepair.bz;
				this.selects[3].obj.bzs = msg.body.carRepair.bzs;
				this.selects[3].obj.nmthc = msg.body.carRepair.nmthc;
				this.selects[3].obj.temp = msg.body.carRepair.temp;
				this.selects[3].obj.pc = msg.body.carRepair.pc;
			})
		}
	}
</script>


<style>
	.level3 {
		padding: 2px;
	}


	template {
		height: 800px;
	}

	#top {
		height: 800px;
		position: relative;
	}


</style>
